import axios from 'axios';
import { cacheAdapterEnhancer } from 'axios-extensions';
import createNetworkingClient from 'utils/networking-client';

import sortAndFilter from './utils';

const CACHE_TTL = 10 * 60 * 1000; // 10 minutes

let networkingClientInstance = null;
const networkingClient = () => {
  if (!networkingClientInstance) {
    networkingClientInstance = createNetworkingClient({
      adapter: cacheAdapterEnhancer(axios.defaults.adapter)
    });
  }
  return networkingClientInstance;
};

const entityMap = { Activity: 'activities', Post: 'posts' };

const getCachedAthletes = () =>
  JSON.parse(localStorage.getItem('strava.cachedAthletes'));

const setCachedAthletes = (data) => {
  localStorage.setItem('strava.cachedAthletes', JSON.stringify(data));
};

const initCache = () => {
  const cachedAthletes = getCachedAthletes();

  if (
    cachedAthletes === null ||
    cachedAthletes.timestamp + CACHE_TTL < new Date().getTime()
  ) {
    setCachedAthletes({
      timestamp: new Date().getTime()
    });
  }
};

const updateCache = (data, url) => {
  const mentionableAthletes = sortAndFilter(data);
  const cachedAthletes = getCachedAthletes();

  cachedAthletes[url] = mentionableAthletes;
  setCachedAthletes(cachedAthletes);

  return mentionableAthletes;
};

const fetchData = (url) => {
  const cachedAthletes = getCachedAthletes();

  if (typeof cachedAthletes[url] !== 'undefined') {
    return new Promise((resolve) => resolve(cachedAthletes[url]));
  }
  return networkingClient()
    .get(url)
    .then(({ data }) => updateCache(data, url));
};

const fetchAthletes = ({ entity, entityId } = {}) => {
  initCache();

  let data;
  if (entity && entityId) {
    data = fetchData(`/${entityMap[entity]}/${entityId}/mentionable_athletes`);
  } else {
    data = fetchData('/athlete/mentionable_athletes');
  }
  return data;
};

export default fetchAthletes;
